import React, {useState, useEffect}  from 'react';
import {Modal, ModalBody} from 'reactstrap';
import {useHistory} from 'react-router-dom';
import ModalCloseButton from 'Components/ModalCloseButton';
import ActionTypes from 'Context/ActionTypes';
import {useCalculatorContext} from 'Utilities/CustomHooks';
import {ROUTES, GET_A_QUOTE_TOKEN} from 'Utilities/Constants';
import QuoteForm from '../GetAQuote/QuoteForm';
import QuoteFormSuccessModal from '../GetAQuote/QuoteFormSuccessModal';

function StoreLocatorModalWrapper(props){
    const {config,...other} = props
    const [modalOpen, setModalOpen] = useState(false);
    const [successModalOpen, setSuccessModalOpen] = useState(false);
    const [state, sendUpdate] = useCalculatorContext();
    const [drinkRecommendations, setDrinkRecommendations] = useState([]);
    const [otherEssentials, setOtherEssentials] = useState([]);
    let history = useHistory();

    const toggleModal = () => setModalOpen(!modalOpen);
    const toggleSuccessQuoteModal = () => setSuccessModalOpen(!successModalOpen);
    
    const redirectToEventSetup = () =>{
        history.push(ROUTES.eventSetup);
    }

    const setStoreInfo = (location) => {
        const storeInfo = {
            name: location.name || "",
            address: location.address || "",
            phoneNumber: location.phone || "",
            email: location.email || "",
        }

        sendUpdate(ActionTypes.setStoreInformation, storeInfo);
    }

    const setCreatedEventData = () => {
        if(state.userEvent && state.userEvent.essentialItems && state.userEvent.recommendations){
            setDrinkRecommendations(state.userEvent.recommendations || []);
            setOtherEssentials(state.userEvent.essentialItems || []);
        }
        setModalOpen(true);
    }

    useEffect(() => {
        // Storepoint widget's 'link-clicked' event fires for every link in a location's detail
        // panel (directions, website, phone, email, social, custom buttons) - see
        // https://storepoint.co/developers/widget-javascript-api#event-listening. Only the
        // "Get a Quote" custom field button should open this modal; token is the field id
        // configured in the Storepoint dashboard and must be kept in sync if it's ever renamed.
        const handleLinkClick = (payload) => {
            if(!payload || payload.type !== 'custom-button' || payload.token !== GET_A_QUOTE_TOKEN){
                return;
            }
            if(payload.location){
                setStoreInfo(payload.location);
            }
            toggleModal();
        }

        // if a user selected create event from the 'get a quote' in store locator,
        // it will be redirected to store locator with the modal opened and the drink details that were just calculated from the state
        if(state.storeInfo.name.length > 0 && state.userEvent){
            setCreatedEventData();
        }

        const registerListener = () => {
            window.storepointWidgetInstance.on('link-clicked', handleLinkClick);
        }

        if(window.storepointWidgetInstance){
            registerListener();
        } else {
            window.addEventListener('storepoint-widget-ready', registerListener);
        }

        return function cleanup(){
            window.removeEventListener('storepoint-widget-ready', registerListener);
            if(window.storepointWidgetInstance){
                window.storepointWidgetInstance.off('link-clicked', handleLinkClick);
            }
        }
    }, [])

    return(
        <div>
            <Modal isOpen={modalOpen} className="store-locator-modal-wrapper" toggle={toggleModal} backdrop={true} backdropClassName="primary-backdrop">
                <ModalBody>
                <ModalCloseButton toggle={toggleModal} set/>
                    <QuoteForm config={config} setIsModalShowing={setModalOpen} setSuccessQuoteModalShowing={setSuccessModalOpen} recommendations={drinkRecommendations} essentials={otherEssentials}/>        
                </ModalBody>
            </Modal>
        
        
            <Modal isOpen={successModalOpen} className="store-locator-modal-wrapper" toggle={toggleSuccessQuoteModal} backdrop={true} backdropClassName="primary-backdrop">
                <QuoteFormSuccessModal toggle={toggleSuccessQuoteModal}/>
            </Modal>
        </div>
    )
}

export default StoreLocatorModalWrapper;